
define('text!modules/targeting/location/templates/panel.html',[],function () { return '<div class="w-box w-LocationTargeting">\n\t<div class="w-body w-panel-body"><!-- The Search & browse views render here--></div>\n\t<div class="w-foot">{{>footer}}</div>\n</div>\n';});

